import { getDescendantProp } from 'app/views/smart-kit/Form/gridFormUtils';
import React from 'react';
import { Controller } from 'react-hook-form';
import SmartAutoComplete from './SmartAutoComplete';

const WithControllerAutoComplete = ({
  control,
  name,
  path,
  label,
  render,
  validation,
  defaultFilters,
  defaultValue,
  disabled,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue || ''}
      rules={validation}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState: { errors },
      }) => (
        <SmartAutoComplete
          value={value}
          // onBlur={onBlur}
          onChange={onChange}
          label={label}
          path={path}
          render={render}
          defaultFilters={defaultFilters}
          error={getDescendantProp(errors, name)}
          disabled={disabled}
        />
      )}
    />
  );
};

export default WithControllerAutoComplete;
